(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-catalog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ptc').forEach(function (root) {
    root.querySelectorAll('[data-role="tab-btn"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tab = btn.getAttribute('data-tab');

        root.querySelectorAll('[data-role="tab-btn"]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });

        root.querySelectorAll('[data-role="tab-panel"]').forEach(function (panel) {
          var isMatch = panel.getAttribute('data-tab') === tab;
          panel.classList.toggle('is-active', isMatch);
          panel.hidden = !isMatch;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-shop"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.pts').forEach(function (root) {
    root.querySelectorAll('[data-role="tab-btn"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tab = btn.getAttribute('data-tab');

        root.querySelectorAll('[data-role="tab-btn"]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });

        root.querySelectorAll('[data-role="tab-panel"]').forEach(function (panel) {
          var isMatch = panel.getAttribute('data-tab') === tab;
          panel.classList.toggle('is-active', isMatch);
          panel.hidden = !isMatch;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
